import { apiCancelarDescargaPost, apiFinalizaDescargaDirigida } from "../../api/descargas";
import { freezeAllDataTables } from "./dataTables";
import { alertCancelarDescarga } from "./descarga.alerts";
import { DescargaCommonGlobal } from "./descarga.global";
import { btnCancelaDescargo, btnDescarga, btnSiguienteMaterial, resetView } from "./view";

/**
 * Si el usuario deside finalizar, se marcan todos los contenedores de exportación como descargados
 * en caso contrario se cancela la descarga
 */
export const finalizaDescarga = async ({ isConfirmed }) => {
    const pedimentoIdEnDescarga = DescargaCommonGlobal.enDescarga.pedimentoId;
    if (isConfirmed) {
        await apiFinalizaDescargaDirigida(pedimentoIdEnDescarga);
    } else {
        await apiCancelarDescargaPost([pedimentoIdEnDescarga]);
    }
    resetView(true);
};

export const cancelarDescargaConfirmed = async () => {
    freezeAllDataTables();

    btnDescarga.disabled = true;
    btnSiguienteMaterial.disabled = true;
    btnCancelaDescargo.disabled = true;

    const pedimentoIdEnDescarga = DescargaCommonGlobal.enDescarga.pedimentoId;

    await apiCancelarDescargaPost([pedimentoIdEnDescarga]);

    resetView(true);
};

const canclearDescargaResult = async ({ isConfirmed }) => {
    if (!isConfirmed) return;
    cancelarDescargaConfirmed();
};

/**
 * Cancelar el proceso de la descarga
 */
export const handleCancelarDescarga = () => {
    alertCancelarDescarga().then(canclearDescargaResult);
};
